import { render, staticRenderFns } from "./PaiementClient.vue?vue&type=template&id=5d357b83&"
import script from "./PaiementClient.vue?vue&type=script&lang=js&"
export * from "./PaiementClient.vue?vue&type=script&lang=js&"
import style0 from "./PaiementClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports